export default __webpack_public_path__ + "static/media/(11).6fb4bcf5.jpg";